import { useEffect, useState } from "react";
import { useGetAdherent } from "../../hooks/useGetAdherent";
import useFetch from "../../hooks/useFetch";
import { usePosition } from "../../hooks/usePosition";
import { useAssisteur } from "../../hooks/useProgramme";
import {
  DemandeAssistance,
  UrlDemandeAssistance,
} from "../../services/Api/swagger";

export interface DemandeAssistanceByNumeroAdhesion {
  numeroAdhesion: string;
  demandeAssistance: DemandeAssistance;
}
export const useDepannage = () => {
  const { position, error } = usePosition();
  const { infoAssisteur } = useAssisteur();
  const { listeAdhesions, listeAdherents } = useGetAdherent();

  // Choix immatriculation
  const immatList =
    listeAdhesions &&
    listeAdhesions
      .filter((a) => a && a.remorquageDepannage === true)
      .map((ad) => ({
        id: ad.immatriculation || " ",
        value: ad.immatriculation || " ",
        numeroAdhesion: ad.numeroAdhesion,
      }));

  const [selectedNumeroAdhesion, setSelectedNumeroAdhesion] = useState<
    string | undefined
  >(immatList && immatList[0] && immatList[0].numeroAdhesion);
  const [selectedImmat, setSelectedImmat] = useState<string | undefined>(
    immatList && immatList[0] && immatList[0].value
  );
  const selectedAdherent = listeAdherents?.find((adh) =>
    adh.listAdhesion?.find((a) => a.numeroAdhesion === selectedNumeroAdhesion)
  );
  const [telephone, setTelephone] = useState<string | undefined>(
    selectedAdherent?.telephone
  );

  const handleChangeImmat = (id, value) => {
    setSelectedImmat(value);
    const findNumeroAdhesion = immatList?.find(
      (immat) => immat.value === value
    );
    setSelectedNumeroAdhesion(findNumeroAdhesion?.numeroAdhesion);
  };

  const handleChangeTel = (e) => {
    setTelephone(e.target.value);
  };

  // APPEL DEPANNAGE EN LIGNE
  const [
    demandeAssistance,
    setDemandeAssistance,
  ] = useState<DemandeAssistanceByNumeroAdhesion>();

  const handleChangeDemandeAssistance = () => {
    if (
      selectedAdherent &&
      telephone &&
      selectedImmat &&
      selectedNumeroAdhesion &&
      selectedAdherent.nom &&
      selectedAdherent.prenom
    ) {
      setDemandeAssistance({
        numeroAdhesion: selectedNumeroAdhesion,
        demandeAssistance: {
          immatriculation: selectedImmat,
          nom: selectedAdherent.nom,
          prenom: selectedAdherent.prenom,
          telephone,
        },
      });
      //  setShouldExecute(true);
    }
  };
  const {
    response: urlDemandeAssistance,
    fetching: fetchingDemandeAssistance,
    error: errorDemandeAssistance,
  } = useFetch<UrlDemandeAssistance>(
    demandeAssistance,
    "postDemandeAssistance",
    demandeAssistance && demandeAssistance.numeroAdhesion ? true : false
  );

  useEffect(() => {
    if (urlDemandeAssistance) {
      window.location.href = urlDemandeAssistance.url;
    }
  }, [urlDemandeAssistance]);
  return {
    position,
    error,
    infoAssisteur,
    selectedAdherent,
    handleChangeImmat,
    handleChangeTel,
    immatList,
    selectedImmat,
    telephone,
    urlDemandeAssistance,
    fetchingDemandeAssistance,
    errorDemandeAssistance,
    handleChangeDemandeAssistance,
    selectedNumeroAdhesion,
  };
};
